<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @reflash="reflash" ref="SetBtn"></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
				id="xpane-0"
				:data="datajson"
				v-loading="loading"
				:highlight-current-row="false"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				header-row-class-name="headerclass"
				:height="tableHeight"
				@cell-dblclick="editInfo"
				tab-click="selectInfo(0)"
				@selection-change="handleSelectionChange"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
				ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="category_code" :label="$t('getapi[6880]')" width="150"></el-table-column>
			<el-table-column show-overflow-tooltip prop="category_name" :label="$t('getapi[6881]')" width="150"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" width="150"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_subject_code" :label="$t('getapi[13396]')" width="150"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_subject_name" :label="$t('getapi[13397]')" width="150"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="100">
				<template slot-scope="scope">
					<el-button @click.native.prevent="edit(scope)" type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
							:confirmButtonText="$t('getapi[6109]')"
							:cancelButtonText="$t('getapi[6]')"
							icon="el-icon-info"
							iconColor="red"
							:title="$t('getapi[637]')"
							@onConfirm="del(scope)"
					>
						<el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[50, 100, 200, 300, 400]"
						:page-size="PageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="purinvoicesubject" ref="ser" @getser="serclick"></serce>
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[6861]')" width="33%" :close-on-click-modal="false">

			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[6880]')}}</td>
						<td>
							<routejump :urlNo="7">
								<el-input
										v-model="formInline.category_code"
										type="text"
										readonly
										size="mini"
								>
									<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectcategory"></i>
								</el-input>
							</routejump>
						</td>
						<td>{{$t('getapi[6881]')}}</td>
						<td><el-input v-model="formInline.category_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[112]')}}</td>
						<td>
							<routejump :urlNo="12">
								<el-input
										v-model="formInline.part_code"
										type="text"
										readonly
										size="mini"
								>
									<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectpart"></i>
								</el-input>
							</routejump>
						</td>
						<td>{{$t('getapi[116]')}}</td>
						<td><el-input v-model="formInline.part_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[13397]')}}</td>
						<td>
							<el-input
									v-model="formInline.part_subject_code"
									type="text"
									readonly
									size="mini"
							>
								<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject"></i>
							</el-input>
						</td>
						<td>{{$t('getapi[13398]')}}</td>
						<td><el-input v-model="formInline.part_subject_name" type="text" size="mini" :readonly="true" class="readO"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<!--选择会计科目-->
		<subjecttable :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
					  :postUrl="'/GL/Basic/GetSubjectPopuDataList'" @callback="getSubject" ref="subject"></subjecttable>
		<!--选择物料编码-->
		<selector :isVisible="false" :selectType="11" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
		<!--选择存货类别-->
		<selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetPartCategory'" @callback="getcategory" ref="category"></selector>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import urlpost from '@/api/config.js';
    export default {
        name: '3_costinventorysubject',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                formInline: {
                    Exclusively_ID: '',
                    part_code: '',
                    part_name: '',
                    category_code: '',
                    category_name: '',
                    part_subject_code: '',
                    part_subject_name: '',
					subjecttype:1,
                },
                oldFormInline:[],
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('3_costinventorysubject'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                subjecttype: '', //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                CargoPositionList: [],
                btn: {
                    del: false,
                    edit: false
                },
                workcostrateEdit:false,
                isVisiblecargo:false,
                scrollTop:0,
                Currency:[], //货币代码
            };
        },
        create() {},
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.getqwlist();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3083]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('create,refresh');
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
                this.authority();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('3_costinventorysubject',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.authority();
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                console.log(parm);
                that.$http.urlpost('GL/Cost/GetCostInventorySubject', parm, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            selectCargo() {
                let that = this;
                that.isVisiblecargo=true;
                that.$refs.cargo.clearInput(true);
            },
            getCargo(data) {
                let that = this
                that.formInline._cargoposition_code = data.cargoposition_code

            },
            // 保存数据
            sava() {
                let that = this;
                if(that.formInline.part_subject_code == ''){
                    that.$message.warning(that.$t('getapi[13433]'))
                    return
                }
                that.loading = true;
                let parm = that.formInline
                that.$http.urlpost('GL/Cost/SaveCostSubject', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();
                        that.editvisi = false;
                    }
                });
                that.loading = false;
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
                    that.queryData = res.DataContent;
                });
            },
            // 编辑
            edit(jsd) {
                let that = this;
                this.editvisi = true;
                this.formInline = {
                    Exclusively_ID: jsd.row.Exclusively_ID,
                    part_code: jsd.row.part_code,
                    part_name: jsd.row.part_name,
                    category_code: jsd.row.category_code,
                    category_name: jsd.row.category_name,
                    part_subject_code:jsd.row.part_subject_code,
                    part_subject_name:jsd.row.part_subject_name,
					subjecttype:jsd.row.subjecttype,
                };
                that.oldFormInline = JSON.stringify(that.formInline)
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
                console.log(that.selectIDData);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('GL/Cost/DeleteCostSubjectByID', parm, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[659]'));
                        that.datajson.forEach(function(item, index) {
                            if (that.ids.indexOf(item.Exclusively_Id) >= 0) {
                                that.datajson.splice(index, 1);
                            }
                        });
                    }
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {});
            },
            // 新增
            add() {
                this.formInline = {
                    Exclusively_ID: '',
                    part_code: '',
                    part_name: '',
                    category_code: '',
                    category_name: '',
                    part_subject_code: '',
                    part_subject_name: '',
					subjecttype:1,
                };
                this.editvisi = true;
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'purinvoicesubject');
            },
            // 刷新
            reflash() {
                this.intidata();
            },
			//科目
            selectSubject(type){
                let that = this
				that.subjecttype = type
                that.$refs.subject.clearInput(true);
            },
            getSubject(data){
                let that = this
                that.formInline.part_subject_code = data['科目编码']
                that.formInline.part_subject_name = data['完整科目名称']
            },
            //物料
            selectpart() {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getpart(data){
                let that = this
                console.log(data)
                that.formInline.part_code = data.part_code;
                that.formInline.part_name = data.part_name;
            },
            //存货类别
            selectcategory() {
                let that = this;
                that.$refs.category.clearInput(true);
            },
            getcategory(data){
                let that = this
                console.log(data)
                that.formInline.category_code = data.Category_Code;
                that.formInline.category_name = data.Category_Name;
            },
        }
    };
</script>

<style lang="scss" scoped>

	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
	.el-form--inline .el-form-item {
		display: flex;
	}

	.tb-edit .el-input {
		display: none;
	}

	.tb-edit .current-row .el-input {
		display: block;
	}

	.tb-edit .current-row .el-input + span {
		display: none;
	}

	.el-table .hidden-row {
		display: none;
	}
</style>
